import { 
    Order_AffiliateSummary as aff

} from "./backend"


const affiliateSummary = async (id,key) => {
    let { data }  = await aff({
        id: id,
        key: key
    });
    return data;
}

export default { affiliateSummary };